import { Box, Button, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import {
  editBgColor,
  editBgImage,
  editCurrentBranchIndex,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { editText } from 'src/store/modules/editText';
import { RootState, useSelector } from 'src/store';
import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import { editBtnAgain, editBtnText } from 'src/store/modules/buttons';
import { TEMPLATES_EDITOR } from 'src/constants/templates';
import { editLogCustom, editTracking } from 'src/store/modules/trackings';
import NumberScroll from '../NumberScroll';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    backgroundColor: '#F5F5F5'
  },
  editor: {
    // margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '0.0175rem'
  },

  scrollNumber: {
    margin: 'auto',
    overflowX: 'auto',
    display: 'flex',
    gap: '32px'
  },
  numberColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px'
  },
  numberBox: {
    maxWidth: '2rem',
    minWidth: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#E0E0E0'
  },

  addSubtract: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #BDBDBD'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },
  slideRight: {
    color: '#828282',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal'
  }
}));

const EditBranch = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  let TEMPLATE_TITLE = location?.pathname
    ?.split('/')?.[2]
    .toUpperCase()
    .split('-')
    .join(' ');

  let currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );
  const CURRENT_BRANCH =
    'multi' + (currentBranchIndex === '' ? '' : `_${currentBranchIndex}`);

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let text = useSelector((state: RootState) => state.editText.text);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let logCustom = useSelector((state: RootState) => state.trackings.logCustom);

  let datas =
    bgImage?.background?.length || bgImage?.image?.length || text?.text?.length;

  const changeDatas = (newData: any, typeList: any, tf: boolean) => {
    for (let i = 0; i < typeList?.length; i++) {
      const currentType = typeList?.[i];
      if (!newData[currentType]) continue;
      if (tf) {
        let newValues =
          newData?.[currentType]?.[newData?.[currentType].length - 1];

        if (currentType.indexOf('option_button') !== -1) {
          newValues = newValues.map(
            (_, idx) =>
              `option ${newData?.[currentType]?.length + 1}-${idx + 1}`
          );
        } else if (
          currentType.indexOf('close') !== -1 &&
          newValues.indexOf('#') === -1
        ) {
          newValues = `${currentType} button ${newData?.[currentType]?.length +
            1}`;
        } else if (currentType.indexOf('left_button') !== -1) {
          newValues = `left button ${newData?.[currentType]?.length + 1}`;
        } else if (currentType.indexOf('right_button') !== -1) {
          newValues = `submit button ${newData?.[currentType]?.length + 1}`;
        } else if (currentType.indexOf('button') !== -1) {
          newValues = `submit button ${newData?.[currentType]?.length + 1}`;
        }

        newData[currentType].push(newValues);
      } else {
        newData[currentType].pop();
      }
    }
    return newData;
  };

  const handleDatas = (tf: boolean) => {
    dispatch(editCurrentIndex(0));

    let newBgImage = JSON.parse(JSON.stringify(bgImage));
    const bgImageType =
      TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.contents?.bgImageType;
    dispatch(editBgImage(changeDatas(newBgImage, bgImageType, tf)));

    let newBgColor = JSON.parse(JSON.stringify(bgColor));
    const bgColorType =
      TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.contents?.bgColorType;
    dispatch(editBgColor(changeDatas(newBgColor, bgColorType, tf)));

    let newDeeplink = JSON.parse(JSON.stringify(deeplink));
    const deeplinkType = TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.contents?.deeplink;
    dispatch(editDeeplink(changeDatas(newDeeplink, deeplinkType, tf)));

    let newText = JSON.parse(JSON.stringify(text));
    const textType = TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.contents?.textType;
    dispatch(editText(changeDatas(newText, textType, tf)));

    let newBtnText = JSON.parse(JSON.stringify(btnText));
    const btnType = TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.buttons?.btnType;
    dispatch(editBtnText(changeDatas(newBtnText, btnType, tf)));

    let newTracking = JSON.parse(JSON.stringify(tracking));
    const trackingType =
      TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.trackings?.trackingType;
    dispatch(editTracking(changeDatas(newTracking, trackingType, tf)));

    let newLogCustom = JSON.parse(JSON.stringify(logCustom));
    const logCustomType =
      TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.trackings?.logCustomType;
    dispatch(editLogCustom(changeDatas(newLogCustom, logCustomType, tf)));
  };

  const BRANCH = TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.branch;
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.title}>
        {TEMPLATE_TITLE?.indexOf('SURVEY') === -1 ? 'SLIDE' : 'QUESTION'}{' '}
        {currentPage}
      </Box>
      <Box className={classes.editor}>
        <NumberScroll branch={BRANCH} setCurrentPage={setCurrentPage} />
      </Box>
      {TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.[CURRENT_BRANCH] && (
        <Box className={classes.addSubtract}>
          <Box style={{ display: 'flex', gap: '1rem' }}>
            <Button
              className={classes.btnMinusPlus}
              disabled={
                datas === TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.multi?.[0]
              }
              onClick={() => handleDatas(false)}
            >
              <Minus
                stroke={
                  datas === TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.multi?.[0]
                    ? '#BDBDBD'
                    : '#000'
                }
              />
            </Button>
            <Button
              className={classes.btnMinusPlus}
              disabled={
                datas === TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.multi?.[1]
              }
              onClick={() => handleDatas(true)}
            >
              <Plus
                stroke={
                  datas === TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.multi?.[1]
                    ? '#BDBDBD'
                    : '#000'
                }
              />
            </Button>
          </Box>
          <span className={classes.slideRight}>
            * Create up to {TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.multi?.[1]}{' '}
            slides
          </span>
        </Box>
      )}
    </Box>
  );
};

export default EditBranch;
